import React from 'react';
import './SiteFooter.css';
import { Link } from 'react-router-dom';

const SiteFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <span className="text-muted">&copy; {currentYear} Todonyx LLC</span>
          <nav>
            <ul className="nav">
              <li className="nav-item">
                <Link to="/" className="nav-link text-muted">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/products" className="nav-link text-muted">
                  Products
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/services" className="nav-link text-muted">
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/about" className="nav-link text-muted">
                  About
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
